import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import firebase from "firebase/app";
import "firebase/analytics";

firebase.initializeApp({
    apiKey: "AIzaSyBzQdC3ry4NvpKJ5I-XZeSC8GMDBFqw13E",
    authDomain: "karamela-app.firebaseapp.com",
    projectId: "karamela-app",
    storageBucket: "karamela-app.appspot.com",
    messagingSenderId: "105539289696",
    appId: "1:105539289696:web:6a9c1ab2a32eae467f7905",
    measurementId: "G-7434MHBDD0"
});
firebase.analytics();

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
